// @ts-nocheck

'use client';

import Commissions from '@/components/V2/Dashboard/Commissions';
import CompanyNews from '@/components/V2/Dashboard/CompanyNews';
import Leaderboard from '@/components/V2/Dashboard/Leaderboard';
import DashboardRankUp from '@/components/V2/Dashboard/Rankup';
import RecentOrders from '@/components/V2/Dashboard/RecentOrders';
import cn from '@/helpers/utils/classNames';
import { useAppSelector } from '@/store';
import { useGetDashboardMetaDataQuery } from '@/store/api/dashboard';
import { StrapiBanner } from '@/types/Banners';

import PetVerticalModal from '../../AccountSetting/PetVertical/PetVerticalModal';
import { useDashboardProvider } from '../../DasboardSidebar/DashboardProvider';
import BOBanner from '../../Dashboard/BOBanner';
import EzshipPVProjection from '../../Dashboard/EzshipPVProjection';
import FirstOrderBonusDetails from '../../Dashboard/FirstOrderBonusDetails';
import ImportantLinks from '../../Dashboard/ImportantLinks';
import PetQuizCount from '../../Dashboard/PetQuizCount';
import VolumnsCardsContainer from '../../Dashboard/VolumnsCardsContainer';
import PawClub from '../../PawClub';
import RpbWidget from '../../RBP';

const Content = ({ bannerData }: { bannerData?: StrapiBanner[] }) => {
  const { toggleMenu, setToggleMenu } = useDashboardProvider();
  const { data, isLoading } = useGetDashboardMetaDataQuery();
  const pawClubMembersData = useAppSelector(state => state.slices.dashboard.dashboardData?.pawClubMembersData) || {};
  const pawClubMembersWithPawPoints = {
    ...pawClubMembersData,
    sampleCreditsEarnedThisMonth: Math.round((Number(pawClubMembersData.pawpointsEarnedThisMonth) || 0) * 100) / 100,
  };

  return (
    <>
      <div
        className={cn(
          'v2-flex v2-gap-4 v2-pb-[30px] v2-flex-col v2-transition-all v2-duration-300 v2-ease-in-out v2-bg-[#F9FAFB] v2-pt-[30px]',
          {
            'v2-px-[165px] 2xl:v2-px-[165px] xl:v2-px-[32px] lg:v2-px-[165px] md:v2-px-[32px] sm:v2-px-[16px] xs:v2-px-[16px]':
              toggleMenu,
            'v2-px-[32px] 2xl:v2-px-[32px] xl:v2-px-[32px] lg:v2-px-[165px] md:v2-px-[32px] sm:v2-px-[16px] xs:v2-px-[16px]':
              !toggleMenu,
          }
        )}
      >
        {bannerData && <BOBanner data={bannerData} />}

        {/* Volume Cards */}
        <VolumnsCardsContainer />

        {/* Widgets */}
        <div className="v2-grid v2-grid-cols-3 xl:v2-grid-cols-3 lg:v2-grid-cols-1 md:v2-grid-cols-1 sm:v2-grid-cols-1 xs:v2-grid-cols-1 v2-gap-[20px] v2-w-full">
          <div className="v2-flex v2-flex-col v2-gap-4">
            {/* <PawtripWidget /> */}

            {/* <RpbWidget /> */}
            {/* Double Dash Widget */}
            {/* <div className="md:v2-hidden v2-block">
              <DoubleDash />
            </div> */}

            <RpbWidget />

            {/* Company News */}
            <CompanyNews />
          </div>
          <div className="v2-flex v2-flex-col v2-gap-4">
            {/* Double Dash Widget */}
            {/* <div className="v2-hidden md:v2-block">
              <DoubleDash />
            </div> */}
            {/* Pet Quiz Count */}
            <PetQuizCount />

            {/* First Order Bounus */}
            <FirstOrderBonusDetails />

            {/* EZ Ship PV Projection */}
            <EzshipPVProjection />

            {/* Commissions */}
            <Commissions />

            {/* Your Recent Orders */}
            <RecentOrders />

            {/* Paw Club Members */}
            <div className="v2-shadow-md v2-p-[24px] md:v2-p-[24px] sm:v2-p-4 xs:v2-p-4 v2-bg-white v2-rounded-xs">
              <div className="v2-pb-5 v2-border-b v2-border-[#E5E5E5] v2-mb-5">
                <h2 className="v2-text-[#333333] v2-font-sweet-sans-pro-bold v2-font-bold v2-text-xl v2-text-center">
                  Paw Club Members
                </h2>
              </div>
              {/* <div>Already impimented</div> */}
              <PawClub
                pawClubMembers={pawClubMembersWithPawPoints}
                shouldHandleVolumeBucket={true}
                isDashboard={true}
              />
            </div>
          </div>
          <div className="v2-flex v2-flex-col v2-gap-4">
            {/* Rank Up */}
            <DashboardRankUp metaLoading={isLoading} metaData={data?.data} />

            {/* PawTree Leaderboard */}
            <Leaderboard />

            {/* Important Links */}
            <ImportantLinks />
          </div>
        </div>
      </div>
      <PetVerticalModal />
    </>
  );
};

export default Content;
